<section class="main-block">
    <app-header appTheme [showorderstatus]="showorderstatusdata" ></app-header>
    <div class="mb-auto">
        <router-outlet></router-outlet>
    </div>
    <div class="mt-auto">
        <app-footer-site-info></app-footer-site-info>
    </div>
    
</section>
